<template>
  <div>
        <el-card>

            <el-table v-loading="listLoading" :data="list">

                <el-table-column label="应用名称" prop='name'></el-table-column>

                <el-table-column label="id" prop='id'></el-table-column>

                <el-table-column label="应用类型" prop='apptype'>
                    <template slot-scope="scope">
                        {{  tableVal(scope.row.apptype,appType)}}
                    </template>
                </el-table-column>

                <el-table-column label="负责人" prop='cname'></el-table-column>

                <el-table-column label="审核状态" prop='approval'>
                    <template slot-scope="scope">
                        {{ tableVal(scope.row.approval,approval)}}
                    </template>
                </el-table-column>

                <el-table-column label="备注" prop='comment'></el-table-column>

                <el-table-column label="操作" width="120" >
                    <template slot-scope="scope">
                        <router-link :to='{ path: "/appcenterTree", query: { type: "detail", ...scope.row } }'>
                            <el-button type="text">详情</el-button>
                        </router-link>
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="listQuery.page_num"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="listQuery.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>

      </el-card>
      
  </div>
</template>

<script>
    import services from './appcenter.services'
    export default {
        data() {
            return {
                list: null,
                total: 0,
                listLoading: true,
                listQuery: {
                    page_num: 1,
                    page_size: 10
                },

            }
        },
    
        mounted() {

            this.fetchData()
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            appType() {
                return this.dictionary.app_type
            },
            approval() {
                return this.dictionary.approval
            },
            username() {
                return this.$store.state.userInfo.user.username
            },
            
        },

        methods: {

            // 请求数据
            fetchData() {
                this.listLoading = true
                let content = {
                    pageIndex: this.listQuery.page_num,
                    pageSize: this.listQuery.page_size,
                    name: this.username
                }
                services.appList({ ...content })
                    .then(res => {
                        this.list = res.app_list
                        this.total = res.total
                    })
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.listLoading = false)
            },

            // 页数改变时
            handleSizeChange(val) {
                let pages = Math.ceil(this.total / val)
                this.listQuery.page_size = val
                if(this.listQuery.page_num > pages ){
                    this.listQuery.page_num  = 1
                }
                this.fetchData()
            },

            // 页码改变时
            handleCurrentChange(val) {
                    this.listQuery.page_num = val
                    this.fetchData()
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },
        }
    }
</script>
